import { useField } from 'formik'
import { LinkAngled } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const TargetLinkField = ({ name = 'targetLink' }: { name?: string }) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <Field icon={LinkAngled} label="Target Link">
      <Input
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter a target link for the campaign"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="targetLink"
      />
    </Field>
  )
}
